import React from 'react';
import classNames from 'classnames';
import { connectToJSContext, RA_73_STERILIZE_HTML_STRING } from '../utils.jsx';
import { readCookie, createCookie, setAriaLabelAttributeForExternalLinks } from '../helpers';
import { Utils } from 'poly-js-utils';

const cookieName = 'warning_msg_';
const cookieLifeTime = 365 * 60 * 60 * 24;

class WarningMessage extends React.Component {

    constructor(props) {
        super(props);
        const {
            warningMessageCanonicalName,
            warningMessageEnabled
        } = props;
        this.state = {
            isDisplayMsg: warningMessageEnabled && !readCookie(cookieName + warningMessageCanonicalName)
        };
    }

    onClickClose = () => {
        createCookie(cookieName + this.props.warningMessageCanonicalName, true, cookieLifeTime);
        this.setState(() => ({
            isDisplayMsg: false
        }));
    };

    replaceDescription = (desc) => {
        const { email, phone} = this.props;
        let formattedDesc = desc;

        formattedDesc = setAriaLabelAttributeForExternalLinks(
            formattedDesc,
            this.props.labels.externalWindowLinkAriaText
        );

        return formattedDesc
            .replace('{phone}', `<a href="tel:${phone}">${phone}</a>`)
            .replace('{email}', `<a href="mailto:${email}">${email}</a>`);
    };

    render() {
        const {
            warningMessageTitle,
            warningMessageDescription,
            warningMessageIsClosable,
            warningMessageIsFluid,
            warningMessageBackgroundColor,
            warningMessageTextColor,
            warningMessageCloseButtonAlt
        } = this.props;


        if (!this.state.isDisplayMsg) {
            return null;
        }

        const style = {};
        if (warningMessageTextColor) {
            style["color"] = warningMessageTextColor;
        }
        if (warningMessageBackgroundColor) {
            style["backgroundColor"] = warningMessageBackgroundColor;
        }

        const warningMsgClass = classNames('warning-message__container', {
            'hsct-container': !warningMessageIsFluid
        });

        return (
            <div className="warning-message" style={style}>
                <div className={warningMsgClass} role="dialog">
                    <div className="warning-message__content">
                        <h3 className="warning-message__title">{warningMessageTitle}</h3>
                        <div
                            className="warning-message__description"
                            dangerouslySetInnerHTML={{
                                __html: RA_73_STERILIZE_HTML_STRING(this.replaceDescription(warningMessageDescription))
                            }}
                        />
                    </div>
                    {warningMessageIsClosable &&
                        <button className="warning-message__close-button"
                            aria-label={warningMessageCloseButtonAlt}
                            onClick={this.onClickClose}
                        >
                            &times;
                        </button>
                    }
                </div>
            </div >
        );
    }
}

const mapStateToProps = (state) => {
    const {
        warning_message_canonical_name,
        warning_message_enabled,
        warning_message_title,
        warning_message_description,
        warning_message_text_color,
        warning_message_background_color,
        warning_message_is_fluid,
        warning_message_is_link_open_new_page,
        warning_message_is_closable,
        warning_message_is_close_button_alt
    } = state.theme_data.warning_msg_options || {};

    return {
        warningMessageTitle: warning_message_title,
        warningMessageCanonicalName: warning_message_canonical_name,
        warningMessageDescription: warning_message_description,
        warningMessageBackgroundColor: warning_message_background_color,
        warningMessageTextColor: warning_message_text_color,
        warningMessageIsFluid: Utils.selectBoxIsTrue(warning_message_is_fluid),
        warningMessageIsLinkOpenNewPage: Utils.selectBoxIsTrue(warning_message_is_link_open_new_page),
        warningMessageIsClosable: Utils.selectBoxIsTrue(warning_message_is_closable),
        warningMessageCloseButtonAlt: warning_message_is_close_button_alt || 'Close message',
        warningMessageEnabled: Utils.selectBoxIsTrue(warning_message_enabled),
        phone: state.profile.phones.phone,
        email: state.profile.email,
        labels: state.theme_data.labels
    };
};

export default connectToJSContext(mapStateToProps)(WarningMessage);



// WEBPACK FOOTER //
// ./components/navigation/warning_message.jsx